import(/* webpackMode: "eager" */ "/codebuild/output/src2581901366/src/skop-manage/src/app/global-error.tsx");
